// Event, Dialog
import EventBus from "@/event/EventBus";
import moment from 'moment';

// Api
import api from '@/api/baseApi';

// Constant
import { SETTINGS_RENTAL_API } from "@/constant/apiSettings";
import { POPUP_ID } from "@/constant/baseConstant";
import { API_CALL_STATUS } from "@/constant/baseConstant";
import { COMMAND_CODE } from "@/constant/machine";
import { SCHEDULER_SHUTDOWN_RESULT } from "@/constant/rental";

// Components
import DateFormat from "@/views/component/RentalService/Notification/DateFormat";
import DateValid from "@/views/component/RentalService/Notification/DateValid";
import InvalidDateWithFixedRental from "@/views/component/RentalService/Notification/InvalidDateWithFixedRental";
import InvalidState from "@/views/component/RentalService/Notification/InvalidState";

// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';

export default {

  extends: baseRentalService,

  components: {
    DateFormat,
    DateValid,
    InvalidDateWithFixedRental,
    InvalidState
  },

  data() {
    return {
      schedulerShutdownsResult: SCHEDULER_SHUTDOWN_RESULT,

      isEnabled: false,
      startAt: null,
      timeRemaining: this.$t('scheduler.calculating'),
    };
  },

  props: {
    targetImage: {
      type: Object,
      default: null,
    },
  },

  computed: {
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: this.$t('scheduler.oneHourLater'),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 1);
              picker.$emit('pick', date);
            }
          },
          {
            text: this.$t('scheduler.twoHoursLater'),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 2);
              picker.$emit('pick', date);
            }
          },
          {
            text: this.$t('scheduler.threeHoursLater'),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 3);
              picker.$emit('pick', date);
            }
          },
          {
            text: this.$t('scheduler.sixHoursLater'),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 6);
              picker.$emit('pick', date);
            }
          },
          {
            text: this.$t('scheduler.twelveHoursLater'),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 12);
              picker.$emit('pick', date);
            }
          },
          {
            text: this.$t('scheduler.oneDayLater'),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },
        ]
      };
    },
  },

  watch: {
    targetImage: function (newVal) {
      this.calculateDefaultValue(newVal);
    }
  },

  mounted() {
    this.calculateDefaultValue(this.targetImage);
  },

  methods: {

    // Close this pop-up
    closeThisPopup() {
      this.closePopup(POPUP_ID.SCHEDULER_MACHINE);
    },

    //Calculate default value
    calculateDefaultValue(targetImage) {
      if (targetImage) {
        this.isEnabled = targetImage.schedulerMachineShutdownMachineEnabled;
        if (targetImage.schedulerMachineShutdownMachineEnabled) {
          this.startAt = moment.utc(targetImage.schedulerMachineShutdownMachineStartAt);
        } else {
          this.startAt = moment.utc(targetImage.endDate || new Date()).add(1, 'hours');
        }
        this.calculateTimeRemaining(this.startAt)
      }
    },

    calculateTimeRemaining(startAt) {
      this.timeRemaining = this.countDown(startAt);
    },

    //#region Save settings
    save() {
      this.feedStatusLoading(API_CALL_STATUS.LOADING);
      setTimeout(() => {
        let data = {
          machineId: this.targetImage.id,
          type: COMMAND_CODE.SHUTDOWN,
          isEnabled: this.isEnabled,
          startAt: this.startAt,
          deviceInformation: JSON.stringify(this.getInformationClient())
        }
        api.baseRequest(SETTINGS_RENTAL_API.SCHEDULER_MACHINE, data)
          .then((res) => {
            switch (res.errorCode) {
              case SCHEDULER_SHUTDOWN_RESULT.SUCCESS:
                EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: [this.targetImage.id] });
                EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                this.closeThisPopup();
                this.notificationSuccess(this.$t('dialog.success'), this.$t('scheduler.scheduledMessage', { id: this.targetImage.id, name: this.targetImage.name }));
                break;
              case SCHEDULER_SHUTDOWN_RESULT.DATE_FORMAT:
              case SCHEDULER_SHUTDOWN_RESULT.DATE_VALID:
                setTimeout(() => {
                  this.isShowErrorInformation = true;
                }, 500);
                this.errorCode = res.errorCode
                break;
              case SCHEDULER_SHUTDOWN_RESULT.INVALID_STATE:
              case SCHEDULER_SHUTDOWN_RESULT.INVALID_TIME_FIXED_RENTAL:
                setTimeout(() => {
                  this.isShowErrorInformation = true;
                }, 500);
                this.errorCode = res.errorCode
                break;
            }
            this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
          })
          .catch(error => {
            this.processCatchApiRequest(error, this.$t('dialog.requestFailed'))
          });
      }, this.smoothTimeOut);
    },
    //#endregion 
  },
}